import React, {useEffect} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import globalContext from '../../../config/context';
import useHook from '../Realisasi/realisasi.hooks';
import './style.css';

//material core
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import {grey} from '@material-ui/core/colors';
import Slide from '@material-ui/core/Slide';

//material icons
import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import MonetizationOnRoundedIcon from '@material-ui/icons/MonetizationOnRounded';

import {Chart, Label, Format, CommonSeriesSettings, Export, Legend, Series, Title, Tooltip} from 'devextreme-react/chart';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select/Select';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import TextField from '@material-ui/core/TextField/TextField';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },

  //button
  button: {
    // position: 'absolute',
    bottom: 30,
    borderRadius: 7,
  },

  buttonShow: {
    // position: 'absolute',
    bottom: 400,
    borderRadius: '8px 8px 0px 0px',
    boxShadow: '0px -5px 5px 0px rgba(0,0,0,0.12)',
    '&:hover': {
      boxShadow: '0px -3px 5px 0px rgba(0,0,0,0.25)',
    },
  },

  //legend content
  box: {
    width: '100vw',
    // padding: '2vh',
    // height: 290,
    // display:'block',
    position: 'absolute',
    bottom: theme.spacing(0),
    right: theme.spacing(0),
    margin: theme.spacing(0),
    backgroundColor: 'white',
  },

  //options
  options: {
    position: 'relative',
    padding: 20,
    backgroundColor: '#fafafa',
    textAlign: 'left',
  },
  gridCaption: {
    position: 'absolute',
    bottom: 20,
  },
  caption: {
    fontSize: 18,
    fontWeight: 500,
  },
  gridComboBox: {
    marginLeft: 90,
  },
  comboBox: {
    width: '100%',
    disabled: 'true',
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(grey[50]),
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#ffffff',
    },
  },
  label: {
    // fontSize: 13,
    textTransform: 'capitalize',
  },
}))(Button);

const RealisasiBottom = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian}, {setPencarian, setAlert, setLoading}] = useAppContext();
  const [{realisasi}, {kecamatan, setKecamatan, kecamatanOptions, handleKecamatan, itemKecamatan}] = useHook(props);

  const [checked, setChecked] = React.useState(false);
  const handleChange = () => {
    document.body.style.overflow = 'hidden';
    setChecked((prev) => !prev);
  };

  useEffect(() => {
    setTimeout(() => {
      document.body.style.overflow = 'unset';
    }, 300);
  }, [checked]);

  useEffect(() => {
    if (pencarian.kecamatan) {
      setKecamatan(pencarian.kecamatan);
    }
  }, [pencarian.kecamatan, setKecamatan]);

  return (
    <div>
      <ColorButton
        variant="contained"
        color="default"
        size="small"
        className={!checked ? classes.button : classes.buttonShow}
        startIcon={<MonetizationOnRoundedIcon />}
        endIcon={!checked ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />}
        onClick={handleChange}>
        Realisasi
      </ColorButton>
      <Slide direction="up" timeout={100} in={checked} mountOnEnter unmountOnExit>
        <Box className={classes.box} boxShadow={3}>
          <div className={classes.options}>
            <Grid container spacing={1}>
              <Grid item xs={1} className={classes.gridCaption}>
                <div className={classes.caption}>Options : </div>
              </Grid>
              <Grid item xs={2} className={classes.gridComboBox}>
                <Autocomplete
                  id="combo-box-kecamatan"
                  className={classes.comboBox}
                  options={itemKecamatan}
                  getOptionLabel={(option) => (option ? option.kd_kecamatan + ' - ' + option.nm_kecamatan : '')}
                  value={kecamatanOptions}
                  onChange={handleKecamatan}
                  renderInput={(params) => <TextField {...params} label="Kecamatan" variant="outlined" />}
                />
              </Grid>
            </Grid>
          </div>

          <Chart id="chart" palette="Soft" dataSource={realisasi}>
            <CommonSeriesSettings
              argumentField="nm_kelurahan"
              type="bar"
              // barWidth={111}
              // barPadding={0.2}
            />
            <Series valueField="penerimaan" name="Penerimaan" color={'#ffaa66'} />
            <Series valueField="tunggakan" name="Tunggakan" color={'#000000'} />

            <Title text="Realisasi PBB" subtitle={'( ' + pencarian.tahun + ' )'} />
            <Export enabled={true} />
            <Tooltip enabled={true} location="edge" customizeTooltip={customizeTooltip} />
            <Legend verticalAlignment="bottom" horizontalAlignment="center" />
          </Chart>
        </Box>
      </Slide>
    </div>
  );
};

const formatNumber = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
}).format;

function customizeTooltip(info) {
  // console.log(info);
  return {
    html: `
        <div>
            <div class="tooltip-header">${info.argumentText}</div>
            <div class="tooltip-body">
               <div class="series-name">${info.seriesName}: </div>
               <div class="value-text">${formatNumber(info.value)}</div> 
            </div>
        </div>
        `,
  };
}

export default RealisasiBottom;
